// @flow
import { combineReducers } from "redux"
import app_data from "./app_data"
import app_settings from "./app_settings"
import pages from "./pages"
import parent_pages from "./parent_pages"
import pre_order_pages from "./pre_order_pages"
import widget_selected from "./widget_selected"
import app_render from "./app_render"
import widgets from "./widgets"
import layout_mail from "./layout_mail"
import layout_reminder_mail from "./layout_reminder_mail"
import app_edited from "./app_edited"
import plan from "./plan"
import pages_config from "./pages_config"
import compare_custom from "./compare_custom"

// Notification Reducer
const notification = (
    state: Object = { content: "", error: false, show: false },
    action: Object,
): Object => {
    switch (action.type) {
        case "NOTIFICATION":
            return { ...action.notifyObject }
        default:
            return state
    }
}

export default combineReducers({
    app_data,
    app_settings,
    notification,
    pages,
    widget_selected,
    app_render,
    widgets,
    layout_mail,
    app_edited,
    layout_reminder_mail,
    plan,
    parent_pages,
    pre_order_pages,
    pages_config,
    compare_custom
    //another_state_prop,
})
